/**
 * Timing constants for BpmnEditor autosave
 */
export const BPMN_TIMING = {
	/** Debounce delay for autosave in milliseconds */
	AUTOSAVE_DEBOUNCE_MS: 1500,
	/** Maximum time to wait before treating an autosave request as stalled */
	AUTOSAVE_STALL_TIMEOUT_MS: 10_000,
	/** Delay before allowing sync after save completes */
	SAVE_LOCK_DELAY_MS: 100,
} as const
